import * as api from '../api/index'
import { ADD_NEW_LOCATION, UPDATE_LOCATION, DELETE_LOCATION, FETCH_LOCATIONS_BY_USER, START_LOADING, END_LOADING } from './constants'

export const getLocationsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchLocationsByUser(searchQuery)
    dispatch({ type: FETCH_LOCATIONS_BY_USER, payload: data })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response || error)
  }
}

export const createLocation = (location, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addLocation(location)
    dispatch({ type: ADD_NEW_LOCATION, payload: data })
    openSnackbar && openSnackbar('Location added successfully')
  } catch (error) {
    console.log(error)
  }
}

export const updateLocation = (id, location, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateLocation(id, location)
    dispatch({ type: UPDATE_LOCATION, payload: data })
    openSnackbar && openSnackbar('Location updated successfully')
  } catch (error) {
    console.log(error)
  }
}

export const deleteLocation = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteLocation(id)
    dispatch({ type: DELETE_LOCATION, payload: id })
    openSnackbar && openSnackbar('Location deleted successfully')
  } catch (error) {
    console.log(error)
  }
}
